import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import CheckoutForm from "./CheckoutForm";

const stripePromise = loadStripe("pk_test_Ev5DQ2RzwAjZ6Q1h3XhVYaO6");

export default class UpgradeForm extends React.Component
{
	constructor(props)
	{
		super(props);
	}

	render()
	{
		return (
			<Elements stripe={stripePromise}>
				<CheckoutForm />
			</Elements>
		);
	}
}



// WEBPACK FOOTER //
// ./Components/components/UpgradeForm.jsx